import { useRouter } from 'next/router'

import Button from 'components/Button'
import Link from 'components/Link'

import { eventConversion } from 'lib/gtag'

import Styled from './styled'

export default function SectionCTA({ data }) {
  const router = useRouter()

  const slug = router?.query?.slug
  const title = data?.title
  const textbtn = data?.button?.title
  const link = data?.button?.url

  return (
    <Styled>
      <div className="text-block">
        <div className="text-cta" dangerouslySetInnerHTML={{ __html: title }} />
      </div>
      <div className="btn-block">
        {slug === 'garage' ? (
          <Button
            dynamic
            className={'btn-cta'}
            onClick={() => {
              eventConversion()
              router.push(link)
            }}
          >
            {textbtn}
          </Button>
        ) : (
          <Link href={link}>
            <Button dynamic className={'btn-cta'}>
              {textbtn}
            </Button>
          </Link>
        )}
      </div>
    </Styled>
  )
}
